import { render, staticRenderFns } from "./TailwindCard.vue?vue&type=template&id=4d8a7a18&"
import script from "./TailwindCard.vue?vue&type=script&lang=js&"
export * from "./TailwindCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports